import { create } from 'zustand';
const initialState = {
    edsInfoForm: null,
    edsEnabled: null,
    edsApplicant: null,
    edsPrequalID: null,
    blackboxData: null,
    edsPersonalInfo: null,
    edsOffer: null,
    edsResult: null,
};
/**
 * @description Set the applicant data from the API response from the Intro form
 */
export const useEDSStore = create((set) => ({
    ...initialState,
    reset: () => set(initialState),
}));
